/**
 * Which build this tab is running, and which build the server is serving now.
 *
 * A single-page app keeps the JavaScript it loaded until the tab reloads. After a deploy that
 * left one tab running validators from the morning against flows from the afternoon and showing
 * forty errors on a clean flow (2026-09-18). The build's main script has a content hash in its
 * name; the served `asset-manifest.json` names the current one.
 */

const MAIN_SCRIPT = /\/static\/js\/main\.[0-9a-f]+\.js/;

/** The path of the main script this page loaded, or null outside a production build. */
export function loadedMainScript(doc = document) {
  const scripts = Array.from(doc.querySelectorAll('script[src]'));
  const main = scripts.map((s) => s.getAttribute('src') || '').find((src) => MAIN_SCRIPT.test(src));
  if (!main) return null;
  return main.match(MAIN_SCRIPT)[0];
}

/** The path of the main script the server is serving now, or null if it cannot be read. */
export async function servedMainScript(fetchImpl = fetch) {
  try {
    const response = await fetchImpl(`/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return null;
    const manifest = await response.json();
    const main = manifest?.files?.['main.js'];
    return typeof main === 'string' && MAIN_SCRIPT.test(main) ? main.match(MAIN_SCRIPT)[0] : null;
  } catch {
    return null;
  }
}
